import React from 'react';
import { useNavigate, useParams } from 'react-router';
import { notification } from 'antd';

import { useAppDispatch, useAppSelector } from 'store';
import {
  IVacanciesItem,
  TVacanciesDraftItem,
} from 'store/slices/vacancies/interfaces';
import { MainLayout } from 'components/Layout/MainLayout';
import {
  saveVacanciesItem,
  loadVacanciesItem,
  saveVacanciesItemAsDraft,
} from 'store/slices/vacancies/actions';
import { StatusesEnum } from 'constants/status';

import { VacanciesForm } from './components/VacanciesForm/VacanciesForm';
import { mapValuesToForm } from './components/VacanciesForm/formUtils';

export const Edit: React.FC = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const { item } = useAppSelector(state => state.vacancies);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  React.useEffect(() => {
    dispatch(loadVacanciesItem(id));
  }, []);

  const onFinish = (values: IVacanciesItem) => {
    setIsLoading(true);
    dispatch(saveVacanciesItem({ ...values, id: item.id }))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Сущность успешно изменена',
        });
        navigate('/vacancies');
      })
      .catch(() => setIsLoading(false));
  };

  const onSaveDraft = (values: TVacanciesDraftItem) => {
    setIsLoading(true);
    dispatch(saveVacanciesItemAsDraft({ ...values, id: item.id }))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Сущность успешно изменена',
        });
        navigate('/vacancies');
      })
      .catch(() => setIsLoading(false));
  };

  const cancelButtonHandler = () => {
    navigate('/vacancies');
  };

  return (
    <MainLayout pageTitle='Редактирование'>
      {item.id && item.id === Number(id) ? (
        <VacanciesForm
          onFinish={onFinish}
          onSaveDraft={onSaveDraft}
          cancelButtonHandler={cancelButtonHandler}
          isDraft={item.status === StatusesEnum.DRAFT}
          isLoading={isLoading}
          initialValues={mapValuesToForm(item)}
        />
      ) : null}
    </MainLayout>
  );
};
